export const AUTH_QUERY_PARAM = 'auth'
export const OTC_QUERY_PARAM = 'otc'
export const OTC_CHALLENGE_QUERY_PARAM = 'otcChallenge'
export const UTM_SIGNUP_COMPLETED_QUERY_PARAM = 'utm_signup_completed'

export type OtcFlow = 'login' | 'signup'

const OTC_CHALLENGE_STORAGE_KEY_PREFIX = 'auth:otc:challenge:'
const OTC_PREFILL_STORAGE_KEY_PREFIX = 'auth:otc:prefill:'

const getChallengeStorageKey = (flow: OtcFlow) =>
  `${OTC_CHALLENGE_STORAGE_KEY_PREFIX}${flow}`

const getPrefillStorageKey = (flow: OtcFlow) =>
  `${OTC_PREFILL_STORAGE_KEY_PREFIX}${flow}`

export const setStoredChallengeId = (flow: OtcFlow, challengeId: string) => {
  if (typeof window === 'undefined') {
    return
  }
  window.sessionStorage.setItem(getChallengeStorageKey(flow), challengeId)
}

export const getStoredChallengeId = (flow: OtcFlow) => {
  if (typeof window === 'undefined') {
    return null
  }
  return window.sessionStorage.getItem(getChallengeStorageKey(flow))
}

export const clearStoredChallengeId = (flow: OtcFlow) => {
  if (typeof window === 'undefined') {
    return
  }
  window.sessionStorage.removeItem(getChallengeStorageKey(flow))
}

export type OtcPrefill = {
  email?: string
  firstName?: string
  lastName?: string
}

export const setStoredPrefill = (flow: OtcFlow, prefill: OtcPrefill) => {
  if (typeof window === 'undefined') {
    return
  }
  window.sessionStorage.setItem(getPrefillStorageKey(flow), JSON.stringify(prefill))
}

export const getStoredPrefill = (flow: OtcFlow): OtcPrefill | null => {
  if (typeof window === 'undefined') {
    return null
  }
  const raw = window.sessionStorage.getItem(getPrefillStorageKey(flow))
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw) as OtcPrefill
  } catch {
    return null
  }
}

export const clearStoredPrefill = (flow: OtcFlow) => {
  if (typeof window === 'undefined') {
    return
  }
  window.sessionStorage.removeItem(getPrefillStorageKey(flow))
}
